// @flow
import { PREFERENCE_OPTIONS } from '../../PeopleProfile/ProspectInfoTabEditMode/utils';

type PreferenceItem = { id: string, weight: number, enabled: boolean };
type Option = { value: string, text: string };

// The waitlist v2 configuration carries every preference id with an enabled
// flag; only the enabled ones are offered on the modal.
export const getPreferenceOptions = (
  waitlistV2Preferences: ?Array<PreferenceItem>,
): Array<Option> => {
  const enabledIds = new Set(
    (waitlistV2Preferences ?? [])
      .filter(({ enabled }) => enabled)
      .map(({ id }) => id),
  );

  return PREFERENCE_OPTIONS.filter(({ value }) => enabledIds.has(value));
};

// The waitlist record stores its preferences as a { [key]: boolean } map,
// while the PATCH schema shared with convert takes the ticked keys as an
// array. Kept local to the modal: the shared copy lived in
// ProspectInfoTabEditMode/utils until the Prospect Info Tab waitlist section
// was removed (ENG-30130), which took the waitlist-only exports with it.
export const preferencesObjectToArray = (
  preferencesObj: ?{ [string]: boolean },
): Array<string> => {
  if (!preferencesObj || typeof preferencesObj !== 'object') return [];

  return Object.entries(preferencesObj)
    .filter(([, enabled]) => Boolean(enabled))
    .map(([key]) => key);
};
